import { PubSubModule } from '../utils/eventUtils';

export const EVENT_BUS_JUMP_REQUESTED = 'JUMP_REQUESTED';
export const EVENT_BUS_ACCOUNT_SWITCH_REQUESTED =
  'EVENT_BUS_ACCOUNT_SWITCH_REQUESTED';

export const JumpEventBus = new PubSubModule();
